import script from "./bottomDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./bottomDialog.vue?vue&type=script&setup=true&lang=ts"

import "./bottomDialog.vue?vue&type=style&index=0&id=ed7a8d68&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed7a8d68"]])

export default __exports__